export default __webpack_public_path__ + "static/Logo-49dd6526e04b745b27a443e1e1999571.png";